import {
  ITransferDetailsPackagesData,
  ITransferDetailsPackagesResponse,
} from '../../../types';

/**
 * This function formats the transfer details packages response.
 */
export function formatTransferDetailsPackagesResponse(
  response: ITransferDetailsPackagesResponse
): ITransferDetailsPackagesData {
  const { inventory, total } = response.data || {};

  return {
    inventory,
    total,
  };
}
